@switch (diagnosticRating()) {
    @case (DiagnosticRating.BAD) {
        <ng-container [ngTemplateOutlet]="badRatingTemplate"></ng-container>
    }
    @case (DiagnosticRating.AVERAGE) {
        <ng-container [ngTemplateOutlet]="averageRatingTemplate"></ng-container>
    }
    @case (DiagnosticRating.GOOD) {
        <ng-container [ngTemplateOutlet]="goodRatingTemplate"></ng-container>
    }
}

<ng-template #badRatingTemplate>
    <div
        [ngClass]="{
            'malou-chip--error min-w-max text-center': !onlyText() || (onlyText() && ratingsToShow().includes(DiagnosticRating.BAD)),
        }">
        @if (partnerTheme()) {
            {{ 'maloupe.rating_chip.bad_rating_partner' | translate }}
        } @else {
            {{ 'maloupe.rating_chip.bad_rating' | translate }}
        }
    </div>
</ng-template>

<ng-template #averageRatingTemplate>
    <div
        [ngClass]="{
            'malou-chip--warn min-w-max text-center': !onlyText() || (onlyText() && ratingsToShow().includes(DiagnosticRating.AVERAGE)),
        }">
        @if (partnerTheme()) {
            {{ 'maloupe.rating_chip.average_rating_partner' | translate }}
        } @else {
            {{ 'maloupe.rating_chip.average_rating' | translate }}
        }
    </div>
</ng-template>

<ng-template #goodRatingTemplate>
    <div
        [ngClass]="{
            'malou-chip--success min-w-max text-center': !onlyText() || (onlyText() && ratingsToShow().includes(DiagnosticRating.GOOD)),
        }">
        @if (partnerTheme()) {
            {{ 'maloupe.rating_chip.good_rating_partner' | translate }}
        } @else {
            {{ 'maloupe.rating_chip.good_rating' | translate }}
        }
    </div>
</ng-template>
